<template>
  <v-container>
    <div id="what" />
    <div class="title-margin text-center teal--text text-sm-h4 text-body-1 font-weight-black text--lightlen-1">
      エネルギーオークションサービスとは
    </div>
    <v-row>
      <v-col cols="12" class="text-center font-weight-black text-sm-h6 text-body-2">
        <div>エネルギーオークションサービスは、全国の小売電気事業者から</div>
        <div>最安の電力契約を見つけられるオークション型の仲介サービスです。</div>
      </v-col>
    </v-row>
    <v-img :src="require('../assets/about_eneoku.png')" />
    <v-row>
      <v-col cols="12" class="text-center">
        <div class="font-weight-black text-sm-h6 text-body-2">
          小売電気事業者がリバースオークション（競り下げ）形式で
        </div>
        <div class="font-weight-black text-sm-h6 text-body-2">
          競争して再入札できる仕組みのため、通常の相見積よりも大幅な安さを実現します。
        </div>
        <div class="text-sm-body-1 text-body-2">
          ※本サービスは、㈱エナーバンクが提供する「エネオク」と提携して運営しています。
        </div>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-btn
        color="error"
        class="font-weight-black text-sm-h6 text-body-2"
        :x-large="$vuetify.breakpoint.smAndUp"
        href="https://rrr.auctions.enerbank.co.jp"
        target="_blank"
        rel="noopener"
      >
        オークション無料登録はこちらから
      </v-btn>
    </v-row>
    <div id="example" />
    <div class="title-margin text-center text-sm-h4 text-body-1 font-weight-black teal--text text--lightlen-1">
      オークションによる電気料金削減事例
    </div>
    <v-row>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="auctions" hide-default-footer disable-sort></v-data-table>
      </v-col>
    </v-row>
    <div id="howto" />
    <div class="title-margin text-center text-sm-h4 text-body-1 font-weight-black teal--text text--lightlen-1">
      ご利用方法
    </div>
    <v-row>
      <v-col cols="12" sm="3"><v-img :src="require('../assets/step1.png')" /></v-col>
      <v-col cols="12" sm="3"><v-img :src="require('../assets/step2.png')" /></v-col>
      <v-col cols="12" sm="3"><v-img :src="require('../assets/step3.png')" /></v-col>
      <v-col cols="12" sm="3"><v-img :src="require('../assets/step4.png')" /></v-col>
    </v-row>
    <div id="feature" />
    <div class="title-margin text-center text-sm-h4 text-body-1 font-weight-black teal--text text--lightlen-1">
      エネルギーオークションの特徴
    </div>
    <v-row>
      <v-col sm="4" cols="12">
        <v-card outlined height="400">
          <v-img :src="require('../assets/system.png')" max-width="450" />
          <v-card-title class="blue--text justify-center font-weight-black">透明性</v-card-title>
          <v-card-text class="text-sm-body-1 text-md-h6">
            人が介在せず、Webシステムで完結させる事で透明性を担保します。
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="4" cols="12">
        <v-card outlined height="400" class="justify-center text-center">
          <v-img :src="require('../assets/auction.png')" max-width="450" />
          <v-card-title class="blue--text justify-center font-weight-black">リバースオークション</v-card-title>
          <v-card-text class="text-sm-body-1 text-md-h6">
            他社の応札額を見ながら最入札可能なリバースオークションにより公正な競争環境を創出します。
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="4" cols="12">
        <v-card outlined height="400">
          <v-img :src="require('../assets/RE100.png')" max-width="450" />
          <v-card-title class="blue--text justify-center font-weight-black">環境メニュー</v-card-title>
          <v-card-text class="text-sm-body-1 text-md-h6">
            比較のしづらい環境メニューも、条件合わせて見積もりの取得ができます。(RE100, CO2フリープラン)
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div id="other" />
    <div class="title-margin text-center teal--text text--lightlen-1 text-sm-h4 text-body-1 font-weight-black">
      その他のサービス
    </div>
    <v-row>
      <v-col offset-lg="1" lg="5" sm="6" cols="12">
        <v-card outlined height="200">
          <v-card-title class="blue--text font-weight-black">
            <div class="card-margin">省エネ診断</div>
            <img :src="require('../assets/documents.png')" height="40" width="40" />
            <img :src="require('../assets/building.png')" height="40" width="40" />
            <img :src="require('../assets/graph1.png')" height="40" width="40" />
          </v-card-title>
          <v-card-text class="text-sm-body-1 text-md-h6">
            エネルギー使用量の明細や計測器を活用して施設の省エネルギー診断を行い、最適な設備使用やPDCAサイクルの構築を提案します。
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="5" sm="6" cols="12">
        <v-card outlined height="200">
          <v-card-title class="blue--text font-weight-black">
            <div :class="$vuetify.breakpoint.mdAndUp ? 'card-margin' : ''">リニューアル提案</div>
            <img :src="require('../assets/paper.png')" height="40" width="40" />
            <img :src="require('../assets/light.png')" height="40" width="40" />
          </v-card-title>
          <v-card-text class="text-sm-body-1 text-md-h6">
            省エネルギーに資する設備のリニューアル提案を行います。同時に補助金の情報・提案を提供します。
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col offset-lg="1" lg="5" sm="6" cols="12">
        <v-card outlined height="200">
          <v-card-title class="blue--text font-weight-black">
            <div class="card-margin">再エネ提案</div>
            <img :src="require('../assets/battery.png')" height="40" width="40" />
            <img :src="require('../assets/building.png')" height="40" width="40" />
            <img :src="require('../assets/pv_panel.png')" height="40" width="40" />
          </v-card-title>
          <v-card-text class="text-sm-body-1 text-md-h6">
            太陽光発電設備や蓄電池を活用したシステム提案や初期費用がかからないPPA（第3者所有モデル）の提案を行います。
          </v-card-text>
          <div class="card-img"></div>
        </v-card>
      </v-col>
      <v-col lg="5" sm="6" cols="12">
        <v-card outlined height="200">
          <v-card-title class="blue--text font-weight-black">
            <div class="card-margin">経営相談</div>
            <img :src="require('../assets/person.png')" height="40" width="40" />
            <img :src="require('../assets/graph2.png')" height="40" width="40" />
          </v-card-title>
          <v-card-text class="text-sm-body-1 text-md-h6">
            中小企業診断士などから経営相談を行います。
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div id="qa" />
    <div class="title-margin text-center text-sm-h4 text-body-1 font-weight-black teal--text text--lightlen-1">
      よくあるご質問
    </div>
    <v-row>
      <v-col class="flex-box text-body-2 text-sm-body-1 text-md-h6">
        <div class="qa-margin"><v-img :src="require('../assets/Q.png')" height="30" width="30"></v-img></div>
        <div>切り替えに工事は発生するのですか？</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="flex-box text-body-2 text-sm-body-1 text-md-h6">
        <div class="qa-margin"><v-img :src="require('../assets/A.png')" height="30" width="30"></v-img></div>
        <div>
          <div>物理的な工事は切り替え前に行う施設外に設置のメーター工事のみです。</div>
          <div>既にスマートメーター化されている場合は遠隔設定のみで不要です。お客様の費用負担は一切ございません。</div>
        </div>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col class="flex-box text-body-2 text-sm-body-1 text-md-h6">
        <div class="qa-margin"><v-img :src="require('../assets/Q.png')" height="30" width="30"></v-img></div>
        <div>電気の品質は低下しないのですか？</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="flex-box text-body-2 text-sm-body-1 text-md-h6">
        <div class="qa-margin"><v-img :src="require('../assets/A.png')" height="30" width="30"></v-img></div>
        <div>
          <div>契約先と電気の品質は関係ありません。</div>
          <div>
            電線から流れる電気は契約によらず一つの大きなプールとなっているため今までと同様の電気が供給されます。
          </div>
        </div>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col class="flex-box text-body-2 text-sm-body-1 text-md-h6">
        <div class="qa-margin"><v-img :src="require('../assets/Q.png')" height="30" width="30"></v-img></div>
        <div>停電、有事の際の対応はどうなるのでしょうか？</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="flex-box text-body-2 text-sm-body-1 text-md-h6">
        <div class="qa-margin"><v-img :src="require('../assets/A.png')" height="30" width="30"></v-img></div>
        <div>各エリアの一般送配電事業者が復旧およびバックアップの役務を提供しているため問題ございません。</div>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="title-margin">
      <v-col sm="8" offset-sm="2" class="button-margin">
        <v-btn
          color="info"
          block
          class="font-weight-black text-sm-h6"
          :x-large="$vuetify.breakpoint.smAndUp"
          href="https://form.run/@rrr-eneoku/"
        >
          問い合わせ・資料ダウンロード
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="8" offset-sm="2" class="button-margin">
        <v-btn
          color="error"
          block
          class="font-weight-black text-sm-h6"
          :x-large="$vuetify.breakpoint.smAndUp"
          href="https://rrr.auctions.enerbank.co.jp"
          target="_blank"
          rel="noopener"
        >
          オークション無料登録はこちらから
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      headers: [
        {
          text: '施設用途',
          value: 'name',
          align: 'center',
          class: 'table-back white--text text-body-1 font-weight-black',
        },
        {
          text: '従来の年間電気料金',
          value: 'current',
          align: 'center',
          class: 'table-back white--text text-body-1 font-weight-black',
        },
        {
          text: '削減額',
          value: 'decrease',
          align: 'center',
          class: 'table-back white--text text-body-1 font-weight-black',
        },
        {
          text: '削減率',
          value: 'percent',
          align: 'center',
          class: 'table-back white--text text-body-1 font-weight-black',
        },
      ],
      auctions: [
        {
          name: '旅館',
          current: '58万円',
          decrease: '12万円',
          percent: '21%',
          class: 'green',
        },
        {
          name: '事務所',
          current: '107万円',
          decrease: '38万円',
          percent: '36%',
        },
        {
          name: 'オフィスビル',
          current: '273万円',
          decrease: '51万円',
          percent: '19%',
        },
        {
          name: 'スポーツ施設',
          current: '244万円',
          decrease: '45万円',
          percent: '18%',
        },
        {
          name: '医療施設',
          current: '1,077万円',
          decrease: '134万円',
          percent: '12%',
        },
        {
          name: '工場',
          current: '3,530万円',
          decrease: '398万円',
          percent: '11%',
        },
      ],
    }
  },
}
</script>
<style lang="scss">
.table-back {
  background-color: #52ab91;
}

.flex-box {
  display: flex;
}

.qa-margin {
  margin-right: 30px;
}

.title-margin {
  margin-top: 80px;
}
.card-margin {
  margin-right: 15px;
}

.button-margin {
  margin: 0 10px;
}

table th + th {
  border-left: 1px dashed #ffffff;
}
table td + td {
  border-left: 1px dashed #ffffff;
}

tbody {
  tr {
    background-color: #e0f2f1;
  }
  td {
    font-size: 1rem !important;
  }
  tr:hover {
    background-color: #e0f2f1 !important;
  }
}
</style>
